export function decorate(target, type, method, callback) {
    const original = target[method];
    if (!original.original) {
        const decorated = async function (...args) {
            var _a, _b;
            try {
                await ((_a = decorated.before) === null || _a === void 0 ? void 0 : _a.apply(this, args));
                const result = await original.apply(this, args);
                await ((_b = decorated.success) === null || _b === void 0 ? void 0 : _b.call(this, result));
                return result;
            }
            catch (e) {
                if (decorated.error) {
                    await decorated.error.call(this, e);
                }
                else {
                    throw e;
                }
            }
        };
        decorated.original = original;
        Object.defineProperty(target, method, {
            value: decorated,
            writable: false,
            enumerable: false
        });
    }
    const decorated = target[method];
    if (typeof callback == 'function')
        decorated[type] = callback;
}
//# sourceMappingURL=decorate.js.map